module.exports = __webpack_public_path__ + "de2d3422.png";